import {
  Activity, AlertCircle, AlertTriangle, ArrowDownLeft,
  ArrowUpRight, BarChart2, Bell, CheckCircle, ChevronLeft,
  FileText, Home, Layers, Loader, Repeat,
  Settings, Slash, Tag, User, XCircle,
  XOctagon, Zap,
} from 'react-feather';
import { BadgeSizes, BadgeTypes } from '@leegality/leegality-react-component-library';
import { AUTOMATION_NAV, Permission } from '@leegality/sequence-automation';
import RouteURLs from './route-urls';
import { FeatureKeys } from '../store/auth-manager';
import CC from '../components/icons/cc-icon';
import StampIcon from '../components/icons/stamp-icon';
import Group from '../components/icons/group-icon';
import TemplatesIcon from '../components/icons/templates-icon';
import WorkflowsIcon from '../components/icons/workflows-icon';
import ContactBookIcon from '../components/icons/contact-book-icon';
import AccountSettingsIcon from '../components/icons/account-settings-icon';
import WalletWithRupeeIcon from '../components/icons/wallet-with-rupee-icon';
import DepartmentIcon from '../components/icons/department-icon';
import NotificationSettingsIcon from '../components/icons/notification-settings-icon';
import Draft from '../components/icons/draft-icon';
import PurchaseOrderIcon from '../components/icons/purchase-order-icon';
import UserX from '../components/icons/user-x-icon';
import WaitingForOthers from '../components/icons/waiting-for-others-icon';
import NeslMonogramIcon from '../components/icons/nesl-monogram-icon';
import { FeatureConfigIds } from './feature-config-rules';
import CustomFieldIcon from '../components/icons/custom-field-icon';

export const NavItemTypes = {
  BUTTON: 'button',
  NAV_LINK: 'nav-link',
  ICON_BUTTON: 'icon-button',
};

export default [
  {
    id: 'overview',
    label: 'DASHBOARD',
    dataTestid: 'nav-list-item-dashboard',
    link: RouteURLs.dashboard,
    icon: Activity,
    testId: 'nav-dashboard',
    children: [
      {
        id: 'home',
        label: 'HOME',
        dataTestid: 'dashboard-side-nav-item-home',
        link: RouteURLs.home,
        icon: Home,
      },
      {
        id: 'activity',
        label: 'ACTIVITY_LOGS',
        dataTestid: 'dashboard-side-nav-item-activity',
        link: RouteURLs.activity,
        icon: Activity,
      },
      {
        id: 'templates',
        label: 'TEMPLATES',
        dataTestid: 'dashboard-side-nav-item-templates',
        restrictImpersonators: true,
        link: RouteURLs.dashboardTemplatesV3,
        icon: TemplatesIcon,
        featureId: FeatureKeys.ONLY_TEMPLATE_V3_MODULE,
      },
      {
        id: 'templates',
        label: 'TEMPLATES',
        dataTestid: 'dashboard-side-nav-item-templates',
        restrictImpersonators: true,
        link: RouteURLs.dashboardTemplates,
        icon: TemplatesIcon,
        featureId: FeatureKeys.TEMPLATE_V4_MODULE,
        className: 'padding-l-10',
        defaultChildIndex: 0,
        children: [
          {
            id: 'template-v3',
            label: 'TEMPLATES',
            dataTestid: 'template-v3-items',
            link: RouteURLs.dashboardTemplatesV3,
          },
          {
            id: 'template-v4',
            label: 'V4_TEMPLATES',
            dataTestid: 'template-v4-items',
            link: RouteURLs.dashboardTemplatesV4Published,
            badgeProps: {
              label: 'NEW',
              showDot: false,
              type: BadgeTypes.WARNING,
              size: BadgeSizes.SMALL,
            },
          },
        ],
      },
      {
        id: 'workflows',
        label: 'WORKFLOWS',
        dataTestid: 'dashboard-side-nav-item-workflows',
        restrictImpersonators: true,
        link: RouteURLs.dashboardWorkflowsV3,
        icon: WorkflowsIcon,
        featureId: FeatureKeys.ONLY_WORKFLOW_V3_MODULE,
      },
      {
        id: 'workflow-v4',
        label: 'WORKFLOWS',
        restrictImpersonators: true,
        dataTestid: 'workflow-v4-items',
        link: RouteURLs.dashboardWorkflowsV4,
        icon: WorkflowsIcon,
        featureId: FeatureKeys.ONLY_WORKFLOW_V4_MODULE,
      },
      {
        id: 'workflows',
        label: 'WORKFLOWS',
        dataTestid: 'dashboard-side-nav-item-workflows',
        restrictImpersonators: true,
        link: RouteURLs.dashboardWorkflows,
        icon: WorkflowsIcon,
        featureId: FeatureKeys.FULL_WORKFLOW_V4_MODULE,
        className: 'padding-l-10',
        defaultChildIndex: 0,
        children: [
          {
            id: 'workflow-v3',
            label: 'WORKFLOWS',
            dataTestid: 'workflow-v3-items',
            link: RouteURLs.dashboardWorkflowsV3,
          },
          {
            id: 'workflow-v4',
            label: 'V4_WORKFLOWS',
            dataTestid: 'workflow-v4-items',
            link: RouteURLs.dashboardWorkflowsV4,
            badgeProps: {
              label: 'NEW',
              showDot: false,
              type: BadgeTypes.WARNING,
              size: BadgeSizes.SMALL,
            },
          },
        ],
      },
      {
        id: 'custom-fields',
        label: 'CUSTOM_FIELDS',
        dataTestid: 'dashboard-side-nav-item-custom-fields',
        restrictImpersonators: true,
        link: RouteURLs.customFields,
        icon: CustomFieldIcon,
        featureId: FeatureKeys.CUSTOM_FIELDS,
        featureConfigId: FeatureConfigIds.CUSTOM_FIELDS,
      },
      {
        id: 'contacts',
        label: 'CONTACT_BOOK',
        dataTestid: 'dashboard-side-nav-item-contacts',
        restrictImpersonators: true,
        link: RouteURLs.dashboardContacts,
        icon: ContactBookIcon,
        featureId: FeatureKeys.CONTACT_BOOK,
      },
      {
        id: 'reports',
        label: 'REPORTS',
        dataTestid: 'dashboard-side-nav-item-reports',
        restrictImpersonators: true,
        link: RouteURLs.dashboardReports,
        icon: BarChart2,
        featureId: FeatureKeys.REPORTS_MODULE,
      },
      {
        id: 'ebg-notifs',
        label: 'EBG_NOTIFICATIONS',
        dataTestid: 'dashboard-side-nav-item-ebg-notifs',
        link: RouteURLs.ebgNotifications,
        icon: Bell,
        featureId: FeatureKeys.EBG_NOTIFICATION,
      },
    ],
  },
  {
    id: 'documents',
    label: 'DOCUMENTS',
    dataTestid: 'nav-list-item-documents',
    link: RouteURLs.documents,
    icon: FileText,
    testId: 'nav-documents',
    children: [
      {
        id: 'sent',
        label: 'SENT',
        dataTestid: 'documents-side-nav-item-sent',
        icon: ArrowUpRight,
        link: RouteURLs.documentsSent,
      },
      {
        id: 'received',
        label: 'RECEIVED',
        dataTestid: 'documents-side-nav-item-received',
        icon: ArrowDownLeft,
        link: RouteURLs.documentsReceived,
      },
      {
        id: 'processing',
        label: 'PROCESSING',
        dataTestid: 'documents-side-nav-item-processing',
        icon: Loader,
        link: RouteURLs.documentsProcessing,
        featureId: FeatureKeys.WORKFLOW_V4_MODULE,
      },
      {
        id: 'cc',
        label: 'CC',
        dataTestid: 'documents-side-nav-item-cc',
        icon: CC,
        link: RouteURLs.documentsCCd,
      },
      {
        id: 'drafts',
        label: 'DRAFTS',
        dataTestid: 'documents-side-nav-item-drafts',
        icon: Draft,
        link: RouteURLs.documentsDrafts,
      },
      {
        id: 'completed',
        label: 'COMPLETED',
        dataTestid: 'documents-side-nav-item-completed',
        icon: CheckCircle,
        link: RouteURLs.documentsCompleted,
      },
      {
        id: 'expired',
        label: 'EXPIRED',
        dataTestid: 'documents-side-nav-item-expired',
        icon: XCircle,
        link: RouteURLs.documentsExpired,
      },
      {
        // Changed Id to documents as only one section could be expanded at one time.
        id: 'documents',
        label: 'QUICK_ACCESS',
        dataTestid: 'documents-side-nav-item-quick-access',
        expanded: true,
        children: [
          {
            id: 'actionRequired',
            label: 'ACTION_REQUIRED',
            dataTestid: 'documents-quick-access-side-nav-item-action-required',
            icon: AlertCircle,
            link: RouteURLs.documentsActionRequired,
          },
          {
            id: 'waitingForOthers',
            label: 'WAITING_FOR_OTHERS',
            dataTestid: 'documents-quick-access-side-nav-item-waiting-for-others',
            icon: WaitingForOthers,
            link: RouteURLs.documentsWaitingForOthers,
          },
          {
            id: 'expiringSoon',
            label: 'EXPIRING_SOON',
            dataTestid: 'documents-quick-access-side-nav-item-expiring-soon',
            icon: AlertTriangle,
            link: RouteURLs.documentsExpiringSoon,
          },
          {
            id: 'failed',
            label: 'FAILED',
            dataTestid: 'documents-quick-access-side-nav-item-failed',
            icon: XOctagon,
            link: RouteURLs.documentsFailed,
          },
          {
            id: 'neslErrors',
            label: 'NESL_ERRORS',
            dataTestid: 'documents-quick-access-side-nav-item-nesl-errors',
            icon: NeslMonogramIcon,
            link: RouteURLs.documentsNeslErrors,
            featureId: FeatureKeys.NESL_MODULE,
          },
          {
            id: 'rejected',
            label: 'REJECTED',
            dataTestid: 'documents-quick-access-side-nav-item-rejected',
            icon: Slash,
            link: RouteURLs.documentsRejected,
          },
        ],
      },
    ],
  },
  {
    id: 'stamps',
    label: 'STAMPS',
    dataTestid: 'nav-list-item-stamps',
    link: RouteURLs.stamps,
    icon: StampIcon,
    testId: 'nav-stamps',
    restrictImpersonators: true,
    featureId: FeatureKeys.STAMP_MODULE,
    featureConfigId: FeatureConfigIds.STAMP_MODULE,
    children: [
      {
        id: 'series',
        label: 'SERIES',
        dataTestid: 'stamps-side-nav-item-series',
        link: RouteURLs.stampSeries,
        icon: Layers,
      },
      {
        id: 'groups',
        label: 'GROUPS',
        dataTestid: 'stamps-side-nav-item-groups',
        link: RouteURLs.stampGroups,
        featureId: FeatureKeys.STAMP_GROUP_MODULE,
        featureConfigId: FeatureConfigIds.STAMP_GROUP,
        icon: Group,
      },
    ],
  },
];

// Which entitlement each automation sub-tab needs to be visible. The package
// names the permission, this app decides what satisfies it, so a product change
// here does not need a package rebuild.
const AUTOMATION_NAV_GATES = {
  [Permission.VIEW_SEQUENCES]: FeatureKeys.AUTOMATION_SEQUENCES,
  [Permission.VIEW_EVENT_RECORDS]: FeatureKeys.AUTOMATION_EVENT_RECORDS,
  [Permission.VIEW_EVENTS]: FeatureKeys.AUTOMATION_EVENTS,
  [Permission.VIEW_CONNECTORS]: FeatureKeys.AUTOMATION_CONNECTORS,
  [Permission.VIEW_CREDENTIALS]: FeatureKeys.AUTOMATION_CREDENTIALS,
  [Permission.VIEW_ACTIVITY_LOGS]: FeatureKeys.AUTOMATION_ACTIVITY_LOGS,
};

export const FooterMenuItems = [
  {
    id: 'accounts',
    title: 'ACCOUNT',
    dataTestid: 'nav-footer-list-item-account',
    link: RouteURLs.accounts,
    icon: Settings,
    type: NavItemTypes.NAV_LINK,
    restrictImpersonators: true,
    isAccountsScreen: true,
    children: [
      {
        id: 'settings',
        label: 'SETTINGS',
        dataTestid: 'accounts-side-nav-item-settings',
        link: RouteURLs.settings,
        icon: AccountSettingsIcon,
        expanded: true,
        children: [
          {
            id: 'profile',
            label: 'PROFILE',
            dataTestid: 'accounts-settings-side-nav-item-profile',
            link: RouteURLs.profile,
            isMobileSupported: true,
            mobileIcon: User,
          },
          {
            id: 'api',
            label: 'API',
            dataTestid: 'accounts-settings-side-nav-item-api',
            link: RouteURLs.api,
            isMobileSupported: true,
            mobileIcon: Repeat,
            featureId: FeatureKeys.API_MODULE,
          },
          {
            id: 'esignAndSeal',
            label: 'ESIGN_AND_SEAL',
            dataTestid: 'accounts-settings-side-nav-item-esignAndSeal',
            link: RouteURLs.esignAndSeal,
          },
          {
            id: 'settingsDocument',
            label: 'DOCUMENTS',
            dataTestid: 'accounts-settings-side-nav-item-documents',
            link: RouteURLs.settingsDocument,
          },
        ],
      },
      {
        id: 'wallet',
        label: 'WALLET',
        dataTestid: 'accounts-side-nav-item-wallet',
        link: RouteURLs.wallet,
        icon: WalletWithRupeeIcon,
        expanded: false,
        featureId: FeatureKeys.WALLET_MODULE,
        children: [
          {
            id: 'purchase',
            label: 'PURCHASE',
            dataTestid: 'accounts-wallet-side-nav-item-purchase',
            link: RouteURLs.purchase,
            isMobileSupported: true,
            mobileIcon: PurchaseOrderIcon,
          },
          {
            id: 'purchaseHistory',
            label: 'PURCHASE_HISTORY',
            dataTestid: 'accounts-wallet-side-nav-item-purchaseHistory',
            link: RouteURLs.purchaseHistory,
          },
          {
            id: 'invoices',
            label: 'INVOICES',
            dataTestid: 'accounts-wallet-side-nav-item-invoices',
            link: RouteURLs.invoices,
          },
          {
            id: 'consumptionHistory',
            label: 'CONSUMPTION_HISTORY',
            dataTestid: 'accounts-wallet-side-nav-item-consumptionHistory',
            link: RouteURLs.consumptionHistory,
          },
          {
            id: 'billingProfiles',
            label: 'BILLING_PROFILES',
            dataTestid: 'accounts-wallet-side-nav-item-billingProfiles',
            link: RouteURLs.billingProfiles,
          },
          {
            id: 'lowBalanceConfigs',
            label: 'LOW_BALANCE_CONFIGS',
            dataTestid: 'accounts-wallet-side-nav-item-lowBalanceConfigs',
            link: RouteURLs.lowBalanceConfigs,
          },
        ],
      },
      {
        id: 'department',
        label: 'DEPARTMENT',
        dataTestid: 'accounts-side-nav-item-department',
        link: RouteURLs.department,
        icon: DepartmentIcon,
        featureId: FeatureKeys.DEPARTMENT_MODULE,
        expanded: false,
        children: [
          {
            id: 'branding',
            label: 'BRANDING',
            dataTestid: 'accounts-department-side-nav-item-branding',
            link: RouteURLs.branding,
            isMobileSupported: true,
            mobileIcon: Tag,
          },
          {
            id: 'security',
            label: 'DOCUMENT_SECURITY',
            dataTestid: 'accounts-department-side-nav-item-security',
            link: RouteURLs.security,
          },
          {
            id: 'eSignature',
            label: 'ESIGNATURE',
            dataTestid: 'accounts-department-side-nav-item-eSignature',
            link: RouteURLs.eSignature,
          },
          {
            id: 'stamp',
            label: 'STAMP',
            dataTestid: 'accounts-department-side-nav-item-stamp',
            link: RouteURLs.stamp,
            featureId: FeatureKeys.STAMP_MODULE,
          },
          {
            id: 'documentConfigs',
            label: 'DOCUMENT_CONFIGS',
            dataTestid: 'accounts-department-side-nav-item-documentConfigs',
            link: RouteURLs.documentConfigs,
          },
          {
            id: 'inviteeConfigs',
            label: 'INVITEE_CONFIGS',
            dataTestid: 'accounts-department-side-nav-item-inviteeConfigs',
            link: RouteURLs.inviteeConfigs,
          },
          {
            id: 'neslEsignConfig',
            label: 'NESL_ESIGN_CONFIG',
            dataTestid: 'accounts-department-side-nav-item-neslEsignConfig',
            link: RouteURLs.neslEsignConfig,
            featureId: FeatureKeys.NESL_MODULE,
          },
          {
            id: 'sftp',
            label: 'SFTP',
            dataTestid: 'accounts-department-side-nav-item-sftp',
            link: RouteURLs.sftp,
            featureId: FeatureKeys.SFTP_MODULE,
          },
          {
            id: 'paymentCollect',
            label: 'PAYMENT_COLLECT',
            dataTestid: 'accounts-department-side-nav-item-paymentCollect',
            link: RouteURLs.paymentCollect,
            featureId: FeatureKeys.PAYMENT_COLLECTION,
          },
          {
            id: 'workflowBuilderConfig',
            label: 'WORKFLOW_BUILDER_CONFIG',
            dataTestid: 'accounts-department-side-nav-item-workflowBuilderConfig',
            link: RouteURLs.workflowBuilderConfig,
            featureId: FeatureKeys.WORKFLOW_BUILDER_CONFIG,
          },
          {
            featureId: FeatureKeys.SENDING_SDK,
            id: 'integrationConfigs',
            label: 'INTEGRATION_CONFIGS',
            dataTestid: 'accounts-department-side-nav-item-integrationConfigs',
            link: RouteURLs.integrationConfigs,
          },
        ],
      },
      {
        id: 'admin',
        label: 'ADMIN',
        dataTestid: 'accounts-side-nav-item-admin',
        link: RouteURLs.admin,
        icon: UserX,
        expanded: false,
        featureId: FeatureKeys.GENERIC_ADMIN_ROLE,
        children: [
          {
            id: 'users',
            label: 'USERS',
            dataTestid: 'accounts-admin-side-nav-item-users',
            link: RouteURLs.users,
          },
          {
            id: 'newUsers',
            label: 'NEW_USERS',
            dataTestid: 'accounts-admin-side-nav-item-newUsers',
            link: RouteURLs.newUsers,
          },
          {
            id: 'departments',
            label: 'DEPARTMENTS',
            dataTestid: 'accounts-admin-side-nav-item-departments',
            link: RouteURLs.departments,
          },
        ],
      },
      {
        // The automation module, served by @leegality/sequence-automation.
        // Children come from the package's exported AUTOMATION_NAV: the package
        // owns the nav data, this app renders it and decides the gates.
        id: 'automation',
        label: 'AUTOMATION',
        dataTestid: 'accounts-side-nav-item-automation',
        link: `${RouteURLs.automation}/${AUTOMATION_NAV[0].path}`,
        icon: Zap,
        expanded: true,
        featureId: FeatureKeys.AUTOMATION_MODULE,
        children: AUTOMATION_NAV.map((item) => ({
          id: `automation_${item.id}`,
          label: item.labelKey,
          dataTestid: `accounts-automation-side-nav-item-${item.id}`,
          link: `${RouteURLs.automation}/${item.path}`,
          featureId: AUTOMATION_NAV_GATES[item.permission],
        })),
      },
      {
        id: 'notifications',
        label: 'NOTIFICATIONS',
        dataTestid: 'accounts-side-nav-item-notifications',
        link: RouteURLs.notifications,
        icon: NotificationSettingsIcon,
        isMobileSupported: true,
        expanded: false,
        featureId: FeatureKeys.NOTIFICATIONS_MODULE,
        children: [],
      },
    ],
  },
];

export const SecondaryMenuItems = [
  {
    id: 'documents',
    label: 'FOLDERS',
    dataTestid: 'documents-secondary-side-nav-item-folders',
    link: RouteURLs.documents,
    children: [],
    expanded: true,
    actions: [],
  },
];

export const BackToMainMenuButton = {
  icon: ChevronLeft,
  id: 'goBack',
  label: 'BACK_TO_MAIN_MENU',
  link: '/dashboard',
  type: 'icon-button',
};

export const DashboardFooterButtonIds = {
  HELP: 'help',
  SWITCH: 'switch',
};

export const TopNavTestIds = {
  LeegalityLogo: 'tn-header-leegality-logo',
  CreateActionBtn: 'tn-create-action-button',
  RedirectionBtn: 'dc-redirection-button',
  HelpContextMenu: 'tn-help-context-menu-button',
  SwitchBackToAccount: 'switch-back-to-account-button',
  UserAvatar: 'user-avatar',
};
